import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Col,
  PageHeader,
  Row,
  Spin,
  message,
  Select,
  Tag,
  Tooltip,
} from "antd";
import {
  ButtonItem,
  Form,
  InputNumberItem,
  SelectItem,
  TextAreaItem,
  FormItem,
  DatePickerItem,
  SelectInsumosItem,
  SwitchItem,
  dineroDisabledMask,
  DisponibilidadInsumoModal
} from "../../../../Components/Items";
import axios from "axios";
import VerRequisicionPdf from "../EditarRequisicion/VerRequisicionPdf/VerRequisicionPdf";
import moment from "moment";
import { ArrowUpOutlined, CarOutlined, EnvironmentOutlined, FileExcelOutlined, FireOutlined, InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { descargarExcelDocumento } from "../../../../Components/DescargarDocumentosMasivo";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import ModalVerRequisicion from "../ModalVerRequisicion/ModalVerRequisicion";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import TrazabilidadSteps from "../../Ventas/TrazabilidadSteps/TrazabilidadSteps";

const { Option } = Select;

class VerRequisicion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    descargandoExcel: false,
    todasProveedores: null,
    objetoProveedoresPInsumos: [],
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: null,
    todasInsumos: [],
    impuestos: [],
    numeroRequisicion: 0,
    presupuestoPU: false,
    presupuestoPUId: null,
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    modalVerPdf: false,
    modalVerPdfId: null,
    todosUsuarios: [],
    objetoUsuarios: null,
    proyectoId: null,
    requisicionesAdicionales: [],
    workbench: this.props?.location?.state?.workbench || false,
    mostrarCostosRequisicion: false,
    modalDisponibilidadVisible: false,
    insumoSeleccionadoDisponibilidad: { id: null, nombre: '', proyectoId: null },
    trace: null,
  };
  componentDidMount() {
    this.consultarTodo();
  }

  abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
    this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
  };

  cerrarDisponibilidad = () => {
    this.setState({ modalDisponibilidadVisible: false });
  };

  abrirModalVerPdf() {
    this.setState({ modalVerPdf: true, modalVerPdfId: this.props.location.state.id })
  }

  async descargarExcel() {
    this.setState({ descargandoExcel: true });
    await descargarExcelDocumento({
      modulo: "requisicion",
      id: this.props.location.state.id,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
    });
    this.setState({ descargandoExcel: false });
  }

  cerrarModalVerPdf() {
    this.setState({ modalVerPdf: false, modalVerPdfId: null })
  }

  verRequisicionModal(id) {
    this.setState({ modalVerRequisicion: true, modalVerRequisicionId: id })
  }

  cerrarModalVerRequisicion() {
    this.setState({ modalVerRequisicion: false, modalVerRequisicionId: null })
  }

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo() {
    this.setState({ loading: true });
    const responseProveedores = axios.post(
      "proveedores/selectProveedoresConTipoDeProveedor",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    );

    const responseProyectos = axios.post(
      "proyectos/selectProyectos",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    );

    const responseConfiguracionRequisiciones = axios.post(
      "requisiciones/configuracionRequisiciones",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    axios.post(
      "usuarios/selectUsuariosEmpresa",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    ).then(res => {
      if (res.data.status === 404) return [];

      this.setState({
        todosUsuarios: res.data,
        objetoUsuarios:
          res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre} {value.apellidoPaterno} {value.apellidoMaterno}
              </Option>
            )
          })
      });
    }
    );


    const responses = await Promise.all([
      responseProveedores,
      responseProyectos,
      responseConfiguracionRequisiciones
    ]);

    let newState = {};

    if (responses[0].data.status === 404) {
    } else {
      newState.todasProveedores = responses[0].data;
      newState.objetoProveedores = responses[0].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.stringBuscar}
          </Option>
        );
      });
    }

    if (responses[1].data.status === 404) {
    } else {
      newState.todasProyectos = responses[1].data;
      newState.objetoProyectos = responses[1].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.nombre}
          </Option>
        );
      });
    }

    if (responses[2]?.data?.success === 2) {
      newState.mostrarCostosRequisicion = responses[2].data.mostrarCostosRequisicion;
    }

    await this.promisedSetState(newState);

    let secondState = { loading: false }

    await axios
      .post(
        "requisiciones/datosRequisicion",
        {
          empresaId: this.props.empresaId,
          requisicionId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          this.setState({ proyectoId: res.data.requisicion.proyectoId, requisicionesAdicionales: res.data.requisicionesAdicionales, trace: res.data.trace || null })
          this.formRef.current.setFieldsValue({
            ...res.data.requisicion,
            solicitanteId: res.data.requisicion.solicitanteId || res.data.requisicion.usuarioId,

            fechaEntrega: res.data.requisicion.fechaEntrega ? moment(res.data.requisicion.fechaEntrega) : null,
            fechaSolicitud: res.data.requisicion.fechaSolicitud ? moment(res.data.requisicion.fechaSolicitud) : null,
          });

          if (res.data.requisicion.insumos && res.data.requisicion?.insumos?.length > 0) {

            const inventarioPromises = res.data.requisicion.insumos.map(async (valueInsumo, index) => {
              const insumo = res.data.insumos.find(
                (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
              );

              if (insumo && (insumo.inventariable || insumo.insumoCompuesto)) {
                try {
                  const inventarioRes = await axios.post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                      proyectoId: this.state.proyectoId,
                      insumoId: valueInsumo.insumoId,
                      noPrincipal: insumo.noPrincipal,
                      insumoCompuesto: insumo.insumoCompuesto,
                      empresaId: this.props.empresaId,
                      pedidosSeleccionados: this.state.pedidosSeleccionados
                    },
                    { headers: this.props.headersToken }
                  );
                  return { index, inventario: inventarioRes.data.cantidad };
                } catch (error) {
                  console.error("Error al obtener inventario:", error);
                  return { index, inventario: null };
                }
              } else if (insumo) {
                return { index, inventario: "No inventariable" };
              }
              return { index, inventario: null };
            });

            const inventarios = await Promise.all(inventarioPromises);

            let insumosConInventario = [...res.data.requisicion.insumos];
            inventarios.forEach(({ index, inventario }) => {
              if (inventario !== null) {
                insumosConInventario[index].inventario = inventario;
              }
            });

            this.formRef.current.setFieldsValue({
              insumos: insumosConInventario
            });


            let objetoProveedoresPInsumos = res.data.requisicion.insumos.map(valueInsumo => {

              const insumo = res.data.insumos.find(
                (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
              );

              if (!insumo) return (
                <Option value={0} key={0} disabled>
                  Seleccione un insumo para ver sus proveedores
                </Option>
              );

              let objetoProveedores = []

              if (insumo.relaciones && insumo.relaciones?.length > 0) {

                let keysProveedores = []

                for (const relacion of insumo.relaciones) {
                  if (relacion.estado !== 0) {

                    const indexProv = keysProveedores.findIndex(valueKey => valueKey.toString() === relacion.proveedorId.toString())

                    if (indexProv === -1) {
                      keysProveedores.push(relacion.proveedorId.toString())
                    }

                  }
                }

                for (const proveedorId of keysProveedores) {

                  const proveedor = this.state.todasProveedores.find(
                    (valueProveedores) =>
                      valueProveedores._id.toString() === proveedorId.toString()
                  );

                  if (!proveedor) continue;

                  objetoProveedores.push(
                    <Option value={proveedor._id} key={proveedor._id}>
                      {proveedor.stringBuscar}
                    </Option>
                  )

                }
              }


              return objetoProveedores;

            })

            secondState.objetoProveedoresPInsumos = objetoProveedoresPInsumos

          }
          secondState.numeroRequisicion = res.data.requisicion.numero
          secondState.presupuestoPU = res.data.requisicion.presupuestoPU
          secondState.presupuestoPUId = res.data.requisicion.presupuestoPUId
          secondState.todasInsumos = res.data.insumos;
        } else {
          message.error("Error no se encontro informacion de la requisición");
        }
      });

    await this.promisedSetState(secondState);
  }
  atras() {
    this.props.history.goBack();
  }

  onOpenTrazabilidad = (stepKey, id) => {
    if (stepKey === "ordenCompra") {
      this.props.history.push("/panel/verOrdenDeCompra", { id });
      return;
    }
    if (stepKey === "requisicion") {
      if (id === this.props.location.state.id) return;
      this.verRequisicionModal(id);
      return;
    }
    message.info("La recepción se consulta desde su orden de compra");
  };

  obtenerColorTagRequisicion = (importancia) => {
    switch (importancia) {
       case 3:
        return "red";
      case 2:
        return "orange";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  getInsumosColumns() {
    const cols = [
      { title: "#", width: "3%" },
      { title: "Clave", width: window.innerWidth < 1600 ? "16%" : "12%" },
      { title: "Insumo", width: window.innerWidth < 1600 ? "36%" : "22%" },
      { title: "Unidad", width: window.innerWidth < 1600 ? "12%" : "8%" },
      { title: "Cant", width: window.innerWidth < 1600 ? "13%" : "10%" },
      { title: "Req.", width: window.innerWidth < 1600 ? "12%" : "8%" },
      { title: "F. Entrega", width: window.innerWidth < 1600 ? "12%" : "8%" },
      { title: "Inv", width: window.innerWidth < 1600 ? "12%" : "8%" },
      { title: "Ord.", width: window.innerWidth < 1600 ? "12%" : "8%" },
      { title: "Proveedor", width: window.innerWidth < 1600 ? "32%" : "20%" },
    ];
    if (this.state.mostrarCostosRequisicion) {
      cols.push({ title: "Costo / Costo con Impuesto", width: window.innerWidth < 1600 ? "20%" : "15%" });
    }
    return cols;
  }

  renderInsumoRow({ key, name, fieldKey: _fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <FormItem noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const insumos = getFieldValue("insumos");
            const insumo = insumos?.[arrayKey];
            const origenesRequisicion = Array.isArray(insumo?.requisicionesOrigen) && insumo.requisicionesOrigen.length > 0
              ? insumo.requisicionesOrigen
              : (insumo?.requisicionId ? [{ requisicionId: insumo.requisicionId, cantidad: insumo?.cantidad }] : []);
            const tagsRequisicion = origenesRequisicion
              .map(origen => this.state.requisicionesAdicionales.find(r => r._id === origen.requisicionId))
              .filter(Boolean)
              .map(req => ({ id: req._id, nombre: req.numero, fechaSolicitud: req.fechaSolicitud, importancia: req.importancia }));
            return (
              <tr>
                <td className="td-border">
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {arrayKey + 1}
                  </div>
                </td>
                <td className="td-border">
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                      const insumoSeleccionado = this.state.todasInsumos?.find(
                        (insumo) => insumo._id.toString() === insumoId?.toString()
                      );
                      return (
                        <div
                          style={{ fontSize: '14px', textAlign: 'center', color: '#868585', cursor: 'pointer' }}
                          onDoubleClick={() => {
                            const idParaDisponibilidad = insumoSeleccionado?.insumoPrincipalId || insumoSeleccionado?._id;
                            this.abrirDisponibilidad(idParaDisponibilidad, insumoSeleccionado?.nombre || insumoSeleccionado?.descripcion || '', this.state.proyectoId);
                          }}
                        >
                          {insumoSeleccionado?.clave || '-'}
                        </div>
                      );
                    }}
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                    <SelectInsumosItem
                      className="select-insumo-wrap"
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Insumo"
                      tiposInsumos="compra"
                      disabled
                      ocultarCodigoYUnidad
                    />
                  </FormItem>
                </td>
                <td className="td-border">
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                    const insumoSeleccionado = this.state.todasInsumos?.find(
                      (insumo) => insumo._id.toString() === insumoId?.toString()
                    );
                    return (
                      <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                        {insumoSeleccionado?.unidad || '-'}
                      </div>
                    );
                  }}
                </FormItem>
              </td>
                <td className="td-border">
                  <FormItem {...restField} name={[name, "cantidad"]} required number noStyle>
                    <InputNumberItem sinBorde disabled placeholder="Cantidad" />
                  </FormItem>
                </td>
                <td className="td-border" style={{ textAlign: "center" }}>
                  {tagsRequisicion.length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                      {tagsRequisicion.map(t => (
                        <Tooltip key={t.id} title={"Fecha de solicitud: " + (t.fechaSolicitud ? moment(t.fechaSolicitud).format("DD/MM/YYYY") : "")}>
                          <Tag color={this.obtenerColorTagRequisicion(t.importancia)} onClick={() => this.verRequisicionModal(t.id)}>
                            {"Req. " + t.nombre}
                          </Tag>
                        </Tooltip>
                      ))}
                    </div>
                  ) : null}
                </td>
                <td className="td-border" style={{ textAlign: "center" }}>
                  <div style={{ fontSize: '14px', color: '#868585' }}>
                    {insumo?.fechaEntrega ? moment(insumo.fechaEntrega).format('DD/MM/YYYY') : '-'}
                  </div>
                </td>
                <td className="td-border">
                  <FormItem {...restField} name={[name, "inventario"]} noStyle>
                    <InputNumberItem sinBorde disabled placeholder="Inventario" />
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem {...restField} name={[name, "cantidadOrdenada"]} noStyle>
                    <InputNumberItem sinBorde placeholder="Cantidad Ordenada" disabled />
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem {...restField} name={[name, "proveedorId"]} margin noStyle>
                    <SelectItem sinBorde style={{ width: "100%" }} placeholder="Proveedor" disabled>
                      {this.state.objetoProveedoresPInsumos[arrayKey]}
                    </SelectItem>
                  </FormItem>
                </td>
                {this.state.mostrarCostosRequisicion ? (
                  <td className="td-border">
                    <FormItem noStyle shouldUpdate>
                      {({ getFieldValue }) => {
                        const costo = getFieldValue(['insumos', arrayKey, 'costo']) || 0;
                        const costoConImpuestos = getFieldValue(['insumos', arrayKey, 'costoConImpuestos']) || 0;
                        return (
                          <div className="celda-totales" style={{ fontSize: '12px' }}>
                            <div>{dineroDisabledMask(costo)}</div>
                            <div className="total-bold">c/Imp: {dineroDisabledMask(costoConImpuestos)}</div>
                          </div>
                        );
                      }}
                    </FormItem>
                    <FormItem {...restField} name={[name, "costo"]} hidden>
                      <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "costoConImpuestos"]} hidden>
                      <InputNumberItem />
                    </FormItem>
                  </td>
                ) : null}
              </tr>
            );
          }}
        </FormItem>
        <FormItem
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.insumos?.[arrayKey]?.observaciones !== curr.insumos?.[arrayKey]?.observaciones
          }
        >
          {({ getFieldValue }) => {
            const arrayValue = getFieldValue("insumos");
            if (arrayValue?.[arrayKey]?.observaciones) {
              return (
                <tr>
                  <td colSpan="11" className="td-border-sin-right">
                    <div style={{ display: "flex", justifyContent: "left", alignItems: "left", backgroundColor: "white" }}>
                      <div style={{ width: "90%", textAlign: "left", paddingLeft: 20 }}>
                        {String(arrayValue[arrayKey].observaciones)
                          .split(/\r?\n/)
                          .map((line, i) => (
                            <span key={i}>{line}<br /></span>
                          ))}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            }
            return null;
          }}
        </FormItem>
      </React.Fragment>
    );
  }


  renderProyectoCard() {
    return (
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          if (!proyectoId) return null;
          const proyecto = this.state.todasProyectos?.find((value) => value._id === proyectoId);
          if (!proyecto) return null;
          return (
            <Row>
              <InfoCard
                title="PROYECTO"
                icon={<InfoCircleOutlined />}
                accentColor="#00BFD6"
                compact
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 8,
                    items: [
                      { label: "Nombre", value: proyecto.nombre || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 8,
                    items: proyecto.calle ? [
                      { label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` },
                    ] : [
                      { label: "Marca", value: proyecto.marca || "-" },
                      { label: "Modelo", value: proyecto.modelo || "-" },
                      { label: "Placas", value: proyecto.placas || "-" },
                    ],
                  },
                  {
                    title: "Detalles",
                    icon: <CarOutlined />,
                    iconColor: "#FF6A0D",
                    lg: 8,
                    items: [
                      { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                      { label: "ID", value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                    ],
                  },
                ]}
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Ver Requisicion #" + this.state.numeroRequisicion}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", marginBottom: 10 }}>
          <TrazabilidadSteps trace={this.state.trace} onOpen={this.onOpenTrazabilidad} />
        </div>
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="verRequisicion"
              layout
            >
              <GeneralFormLayout
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 12,
                    content: (
                      <Row>
                        <Col span={24}>
                          <FormItem label="Fecha Solicitud" name="fechaSolicitud" margin>
                            <DatePickerItem disabled placeholder="Fecha de Solicitud" />
                          </FormItem>
                          <FormItem label="Fecha Entrega" name="fechaEntrega" margin>
                            <DatePickerItem disabled placeholder="Fecha de Entrega" />
                          </FormItem>
                          <FormItem
                            label="Solicitante"
                            name="solicitanteId"
                            tooltip="Usuario que solicita la requisicion"
                            margin
                          >
                            <SelectItem disabled placeholder="Seleccione al solicitante">
                              {this.state.objetoUsuarios}
                            </SelectItem>
                          </FormItem>
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem disabled placeholder="Proyecto">
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Extras",
                    lg: 12,
                    content: (
                      <>
                        <FormItem
                          label="Separar Ins:"
                          name="separarInsumos"
                          margin
                          initialValue={false}
                          valuePropName="checked"
                          tooltip="Indica si se separan los insumos al recibir la orden de compra"
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 19 }}
                        >
                          <SwitchItem disabled />
                        </FormItem>
                        <FormItem
                          label="Importancia"
                          name="importancia"
                          tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta"
                          margin
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 19 }}
                        >
                          <SelectItem placeholder="Seleccione nivel de importancia" disabled style={{ width: "100%" }}>
                            <Option value={1}>
                              <Tag color="green" style={{ marginRight: 8 }}>
                                <ArrowUpOutlined /> Baja
                              </Tag>
                            </Option>
                            <Option value={2}>
                              <Tag color="orange" style={{ marginRight: 8 }}>
                                <WarningOutlined /> Media
                              </Tag>
                            </Option>
                            <Option value={3}>
                              <Tag color="red" style={{ marginRight: 8 }}>
                                <FireOutlined /> Alta
                              </Tag>
                            </Option>
                          </SelectItem>
                        </FormItem>
                        {this.state.workbench && (
                          <FormItem
                            label="Prov."
                            name="proveedorId"
                            margin
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 19 }}
                          >
                            <SelectProveedoresItem
                              empresaId={this.props.empresaId}
                              headersToken={this.props.headersToken}
                              sinBorde
                              autoFocus
                              disabled
                              dropdownMatchSelectWidth={600}
                              width="100%"
                              placeholder="Proveedor"
                            />
                          </FormItem>
                        )}
                        <FormItem
                          label="Obsr."
                          name="observaciones"
                          margin
                          labelCol={{ span: 5 }}
                          wrapperCol={{ span: 19 }}
                          pattern
                        >
                          <TextAreaItem disabled placeholder="Observaciones" />
                        </FormItem>
                      </>
                    ),
                  },
                ]}
              />

              <div style={{ padding: '0 16px', marginBottom: 16 }}>
                {this.renderProyectoCard()}
              </div>

              <GeneralFormLayout
                tabsConfig={{
                  tableClassName: "tabla-insumos-venta requisiciones-celdas-amplias",
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                    },
                  ],
                  defaultActiveKey: "insumos",
                  formInstance: this.formRef.current,
                  isMobile: window.innerWidth <= 1000,
                }}
                //observacionesConfig={this.getObservacionesConfig()}
                actionButtons={
                  <>
                    <ButtonItem
                      type="primary"
                      cyanB
                      hotkey="alt+v"
                      style={{ display: "inline-block" }}
                      onClick={() => this.abrirModalVerPdf()}
                    >
                      Ver Requisicion
                    </ButtonItem>
                    <ButtonItem
                      icon={<FileExcelOutlined />}
                      verdeB
                      style={{ display: "inline-block" }}
                      loading={this.state.descargandoExcel}
                      onClick={this.descargarExcel.bind(this)}
                    >
                      Descargar Excel
                    </ButtonItem>
                  </>
                }
              />
            </Form>
          </Spin>
        </div>
        <VerRequisicionPdf
          visible={this.state.modalVerPdf}
          requisicionId={this.state.modalVerPdfId}
          onCancel={this.cerrarModalVerPdf.bind(this)}
          cerrarModalVerPdf={this.cerrarModalVerPdf.bind(this)}
        />
        <ModalVerRequisicion
          visible={this.state.modalVerRequisicion}
          requisicionId={this.state.modalVerRequisicionId}
          onClose={this.cerrarModalVerRequisicion.bind(this)}
          cerrarModalVerRequisicion={this.cerrarModalVerRequisicion.bind(this)}
        />
        <DisponibilidadInsumoModal
          visible={this.state.modalDisponibilidadVisible}
          onClose={this.cerrarDisponibilidad}
          insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
          nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerRequisicion);
